import LoyaltyProgramLoginForm, {
  Fields as LoyaltyProgramLoginFormFields,
} from 'forms/loyalty-program/LoyaltyProgramLoginForm';

import { Dialog, DialogContent, DialogHeading } from 'omakase';
import { StoreType } from '@tock/shared/utils/connect';
import { consumer, safeEnumCompare } from '@tock/coretypes';
import { getLoyaltyProgramDetails } from 'components/loyalty-program/LoyaltyProgramConstants';
import LoyaltyProgramRedemptionForm, {
  Fields as LoyaltyProgramRedemptionFormFields,
} from 'forms/loyalty-program/LoyaltyProgramRedemptionForm';
import protos from 'utils/protos';

const { LoyaltyProgramConsumerTheme } = protos;

interface Props {
  business: consumer.IBusinessConfig;
  isOpen: boolean;
  loyaltyProgram: StoreType['loyaltyProgram'];
  onFinish(values: LoyaltyProgramRedemptionFormFields): void;
  onClose(): void;
  onLogin(values: LoyaltyProgramLoginFormFields): Promise<void>;
}

const LoyaltyProgramModal: React.FunctionComponent<Props> = ({
  business,
  loyaltyProgram,
  onClose,
  onLogin,
  onFinish,
  isOpen,
}) => {
  const loyaltyProgramTheme = business.loyaltyProgramTheme;
  const loyaltyProgramDetails =
    loyaltyProgramTheme && getLoyaltyProgramDetails(loyaltyProgramTheme);
  return (
    <Dialog variant="partial" onClose={onClose} open={isOpen}>
      <DialogHeading onClose={onClose} />
      <DialogContent disablePadding>
        {loyaltyProgramDetails?.logoUrl && (
          <div className="ConsumerCheckout-loyaltyProgram-logoHeader">
            <img
              className="ConsumerCheckout-loyaltyProgram-logo"
              src={loyaltyProgramDetails.logoUrl}
              alt={`${loyaltyProgramDetails.businessName} logo`}
            />
          </div>
        )}
        {!(loyaltyProgram?.balance?.username || '') && (
          <LoyaltyProgramLoginForm
            business={business}
            isLoading={loyaltyProgram.requestInProgress}
            onSubmit={onLogin}
            useUsername={safeEnumCompare(
              loyaltyProgramTheme,
              LoyaltyProgramConsumerTheme,
              LoyaltyProgramConsumerTheme.FABIO_TRABOCCHI_GROUP
            )}
          />
        )}
        {loyaltyProgram?.balance?.username && (
          <LoyaltyProgramRedemptionForm
            loyaltyProgram={loyaltyProgram}
            onSubmit={(values) => onFinish({ points: values.points })}
            showDollarSign={loyaltyProgramDetails?.showDollarSign}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default LoyaltyProgramModal;
